import { useState } from 'react'
import PermissionsCheck from '../../../../../components/PermissionsCheck'
import { Permission } from '../../../../../graphql'

import {
	EuiButton,
	EuiFieldText,
	EuiFormRow,
	EuiModalBody,
	EuiModalFooter,
} from '@equipmentshare/ds2'

export type ProviderFormProps = {
	canMerge?: boolean,
	onCancel: () => void,
	onMerge?: () => void,
	onSubmit: ( args: { id: number | null, name: string } ) => Promise<any>,
	onSuccess: () => void,
	provider?: {
		id?: number | null,
		name?: string,
	},
}

export default function ProviderForm( {
	canMerge,
	onMerge,
	onCancel,
	onSubmit,
	onSuccess,
	provider,
}: ProviderFormProps ) {
	const [ isSaving, setIsSaving ] = useState( false )
	const [ name, setName ] = useState( provider?.name ?? '' )

	const handleNameChange = ( event: React.ChangeEvent<HTMLInputElement> ) => setName( event.currentTarget.value )
	const handleSubmit = async() => {
		setIsSaving( true )
		await onSubmit( {
			id: provider?.id ?? null,
			name
		} )
		setIsSaving( false )
		onSuccess()
	}
	return (
		<>
			<EuiModalBody>
				<EuiFormRow
					label="Name"
				>
					<EuiFieldText
						onChange={handleNameChange}
						value={name}
					/>
				</EuiFormRow>

			</EuiModalBody>
			<EuiModalFooter>
				{ canMerge && onMerge && (
					<PermissionsCheck permissionsToCheck={[ Permission.CanMergeProviders ]}>
						<EuiButton
							onClick={onMerge}
						>
							Merge manufacturers
						</EuiButton>
					</PermissionsCheck>
				) }
				<EuiButton
					color="text"
					onClick={onCancel}
				>
					Cancel
				</EuiButton>
				<EuiButton
					fill
					isLoading={isSaving}
					onClick={handleSubmit}
				>
					Submit
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
